/* eslint-disable no-redeclare */

import { z } from 'zod';

import {
  DateOfBirth,
  FirstName,
  Gender,
  LastName,
  TobaccoUse,
} from '../primitive';

export const MemberBase = z.object({
  firstName: FirstName.optional(),
  lastName: LastName.optional(),
  gender: Gender.optional(),
  tobaccoUse: TobaccoUse.optional(),
  dateOfBirth: DateOfBirth.optional(),
});

export type MemberBase = z.infer<typeof MemberBase>;
